import { render } from "./TariffSlider.vue?vue&type=template&id=57832b52&scoped=true"
import script from "./TariffSlider.vue?vue&type=script&lang=js"
export * from "./TariffSlider.vue?vue&type=script&lang=js"

import "./TariffSlider.vue?vue&type=style&index=0&id=57832b52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57832b52"]])

export default __exports__